import { User } from 'lucide-react';

const UserInfoSection = () => {
	return (
		<section className="space-y-6">
			<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
				<div className="space-y-2">
					<label htmlFor="id" className="block text-sm font-semibold text-gray-700 mb-1">
						아이디
					</label>
					<input
						type="text"
						id="id"
						name="id"
						placeholder="아이디를 입력해주세요"
						className="w-full sm:flex-1 px-4 py-3 rounded-lg border text-sm transition border-red-500 focus:ring-red-500 focus:border-red-500"
					/>
				</div>
				<div className="space-y-2">
					<label htmlFor="id" className="block text-sm font-semibold text-gray-700 mb-1">
						비밀번호
					</label>
					<input
						type="password"
						id="password"
						name="password"
						placeholder="비밀번호를 입력해주세요"
						className="w-full sm:flex-1 px-4 py-3 rounded-lg border text-sm transition border-red-500 focus:ring-red-500 focus:border-red-500"
					/>
				</div>
			</div>
		</section>
	);
}

export default UserInfoSection;